import React from 'react';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';

const StyledTopBar = styled(Box)`
    flex: 0 0 auto;
`;
const StyledHeader = styled(Box)`
    flex: 0 0 auto;
`;
const StyledContent = styled(Box)`
    flex: 1 1 auto;
`;
const StyledFooter = styled(Box)`
    flex: 0 0 auto;
    margin-top: auto;
`;
const StyledSiteLayout = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100vw;
    min-height: 100%;
`;
const SiteLayout = ({ children }) => /* @__PURE__ */ React.createElement(StyledSiteLayout, null, children);
SiteLayout.TopBar = StyledTopBar;
SiteLayout.Header = StyledHeader;
SiteLayout.Content = StyledContent;
SiteLayout.Footer = StyledFooter;
SiteLayout.displayName = "SiteLayout";

export { SiteLayout };
//# sourceMappingURL=SiteLayout.es.js.map
